import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { genericVehicleTypes, trackerTypes } from "helpers/enums";
import { paths } from "helpers/paths";
import { EnumColumnFilter, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import policy from "policies";
import React from "react";
import { Link } from "react-router-dom";
import { getCarsAndTrailers as allCarsAndTrailers, getOrganizationNames } from "sources/admin";
import { upload } from "sources/books/trackers";
import { getCarsAndTrailers as organizationCarsAndTrailers } from "sources/vehicle";

class TrackersList extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Номер",
                accessor: "deviceNumber",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => {
                    const { isRoot, isTechSupport, isIntegrationManager, isTruckingOrganizationAdmin } =
                        this.props.roles;
                    if (isRoot || isTechSupport || isIntegrationManager) {
                        return <Link to={paths.trackersShow(id)}>{value}</Link>;
                    } else if (isTruckingOrganizationAdmin) {
                        return <Link to={paths.trackerOdometerValues(id)}>{value}</Link>;
                    } else {
                        return value;
                    }
                },
            },
            {
                Header: "Тип",
                accessor: "type",
                filterable: true,
                filterType: "enum",
                Filter: (props) => <EnumColumnFilter {...props} filterEnum={trackerTypes} />,
                Cell: ({ value }) => enumLabel(trackerTypes, value, "Не указано"),
                CSVExport: ({ value }) => enumLabel(trackerTypes, value, "Не указано"),
            },
            {
                Header: "Организация",
                accessor: "organizationName",
                id: "organizationId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getOrganizationNames,
                            inputProps: { name: "organizationId" },
                            propName: "name",
                        }}
                    />
                ),
                Cell: ({ value }) => value,
                CSVExport: ({ value }) => value?.replace(/"/g, ""),
                show: policy("user", { user: { roles: this.props.roles } }).isAdmin(),
            },
            {
                Header: "Дата создания",
                accessor: "createdAt",
                sortable: true,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            {
                Header: "Период трекера",
                accessor: "activeTrackerPeriod",
                sortable: false,
                Cell: ({ value }) =>
                    value
                        ? [
                              dateTimeToView(value.startedAt, "DD.MM.YYYY HH:mm:ss"),
                              dateTimeToView(value.endedAt, "DD.MM.YYYY HH:mm:ss"),
                          ].join(" — ")
                        : "",
                CSVExport: ({ value }) =>
                    value
                        ? [
                              dateTimeToView(value.startedAt, "DD.MM.YYYY HH:mm:ss"),
                              dateTimeToView(value.endedAt, "DD.MM.YYYY HH:mm:ss"),
                          ].join(" — ")
                        : "",
            },
            {
                Header: "Дата последней координаты",
                accessor: "lastTrackerLogFixedAt",
                sortable: true,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            {
                id: "activeTrackerPeriod/entityId",
                Header: "Привязанный объект",
                accessor: "activeTrackerPeriod",
                filterable: true,
                filterType: "carAndTrailerSelect",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url:
                                this.props.roles.isRoot ||
                                this.props.roles.isTechSupport ||
                                this.props.isIntegrationManager
                                    ? allCarsAndTrailers
                                    : organizationCarsAndTrailers,
                            inputProps: { name: "entityId" },
                            propName: "number",
                        }}
                    />
                ),
                Cell: ({ value }) =>
                    value ? (
                        <span>
                            <span className="text-muted">{enumLabel(genericVehicleTypes, value.type)}:</span>{" "}
                            {value.number}
                        </span>
                    ) : (
                        "Не привязан"
                    ),
                CSVExport: ({ value }) =>
                    value ? `${enumLabel(genericVehicleTypes, value.type)}: ${value.number}` : "Не привязан",
            },
        ].filter((item) => item.show ?? true);
    }

    renderHead = () => {
        return (
            <div className="book-list__head">
                <div className="book-list__head-close close close--sm" onClick={this.close} />
                <div className="book-list__head-title">
                    {this.props.title}
                    {this.renderCounter()}
                </div>
                <div className="btn-toolbar">{this.renderImportButton()}</div>
            </div>
        );
    };

    renderImportButton = () => {
        const { modal, mergeParams } = this.props;
        const { isRoot, isTechSupport, isIntegrationManager } = this.props.roles;
        if (!(isRoot || isTechSupport || isIntegrationManager)) {
            return null;
        }
        const action = () =>
            modal({
                name: "importTrackers",
                title: "Загрузить трекеры",
                action: upload,
                propName: "file",
                onCloseAction: () => mergeParams({}),
            });
        return (
            <a className="btn btn-brand btn-sm" onClick={action}>
                Загрузить трекеры
            </a>
        );
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(TrackersList, "trackers");
